const discuss = $('.js-discuss');
let positionScroll = 0;

// function debounce(method, delay) {
//   clearTimeout(method._tId);
//   method._tId= setTimeout(function(){
//     method();
//   }, delay);
// }

function indicatorScroll() {
  let currentScroll = $(window).scrollTop();

  if (positionScroll < currentScroll) {
    // window scroll down
    discuss.addClass('is_show');
  } else {
    // window scroll up
    discuss.removeClass('is_show');
  }

  positionScroll = currentScroll;
}

if ($('.js-discuss').length > 0) {
  $(window).on('scroll', function() {
    indicatorScroll();
  });
}